export default {
  loading: 'Assigning device to organisation...',
  success: 'Device assigned to organisation successfully',
  error: 'Failed to assign device',
};
